import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col } from "react-bootstrap";
import messages from '../../assets/i18n';
import moment from "moment";

function SelectOrderOnModal(props) {

	const dispatch = useDispatch();
	const lang = useSelector(state => state.language.name);
	const [checked, setCheked] = useState(false);

	const handleChecked = (orderId) => {
		if (checked === false) {
			setCheked(true);

			dispatch({
				type: "MODAL_ADD_ORDER",
				orderId: orderId
			});
		} else {
			setCheked(false);

			dispatch({
				type: "MODAL_REMOVE_ORDER",
				orderId: orderId
			});
		}
	};

	const { order } = props;

	return (
		<Row className="mt-2" onClick={() => handleChecked(order.id)}>
			<Col className="d-flex">
				<Col className="bg-color-secondary col-0-5 py-2 border-right">
					<div className="custom-checkbox">
						<input
							type="checkbox"
							checked={checked}
						/>
						<div className="custom-checkbox-style-2" />
					</div>
				</Col>

				<Col className="bg-color-secondary py-2 border-left border-right">
					<span className="text-2">{order.id}</span>
				</Col>

				<Col className="bg-color-secondary py-2 border-left border-right">
					<span className="text-2">{order.qtCompra}</span>
				</Col>

				<Col className="bg-color-secondary py-2 border-left border-right">
					<span className="text-2">{order.qtVolumes}</span>
				</Col>

				<Col className="bg-color-secondary py-2 border-left border-right">
					<span className="text-2">{moment(order.dtEmissao).format('L')}</span>
				</Col>

				<Col className="bg-color-secondary py-2 border-left border-right">
					<span className="text-2">{order.naturezaPedido}</span>
				</Col>

				<Col className="bg-color-secondary py-2 border-left">
					<span className="text-2">{messages[lang].statusOrder[order.status]}</span>
				</Col>
			</Col>
		</Row>
	)
}

export default SelectOrderOnModal;